import React, { useState } from 'react';
import { storeGetOrDefault, storeSet, DEF_ADVANTAGES } from '../../store';
import '../admin.css';

const empty = (order) => ({ id: Date.now(), num: String(order).padStart(2,'0'), title: '', body: '' });

const Toast = ({ msg, type }) => msg ? <div className={`adm-toast adm-toast-${type}`}>{msg}</div> : null;

const AdvantagesAdmin = () => {
  const [items, setItems] = useState(() => storeGetOrDefault('advantages', DEF_ADVANTAGES));
  const [mode, setMode]   = useState(null);
  const [form, setForm]   = useState(empty(1));
  const [toast, setToast] = useState({ msg: '', type: 'success' });

  const showToast = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast({ msg: '', type: 'success' }), 3000); };
  const save      = (list) => { setItems(list); storeSet('advantages', list); };

  const openAdd  = () => { setForm(empty(items.length + 1)); setMode('add'); };
  const openEdit = (a) => { setForm({ ...a }); setMode('edit'); };
  const close    = () => setMode(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.title.trim()) return showToast('Title is required.', 'error');
    if (mode === 'add') { save([...items, { ...form, id: Date.now() }]); showToast('Advantage added!'); }
    else { save(items.map(a => a.id === form.id ? { ...form } : a)); showToast('Updated!'); }
    close();
  };

  const del  = (id) => { if (window.confirm('Delete this advantage card?')) { save(items.filter(a => a.id !== id)); showToast('Deleted.', 'info'); } };
  const move = (idx, dir) => {
    const list = [...items]; const swap = idx + dir;
    if (swap < 0 || swap >= list.length) return;
    [list[idx], list[swap]] = [list[swap], list[idx]]; save(list);
  };

  const field = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  return (
    <div className='adm-page'>
      <Toast {...toast} />
      <div className='adm-header'>
        <div><h1 className='adm-title'>Advantages</h1><p className='adm-subtitle'>{items.length} advantage cards shown on the Advantages page</p></div>
        <button className='adm-btn adm-btn-primary' onClick={openAdd}>+ Add Card</button>
      </div>

      <div className='adm-table-wrap'>
        <table className='adm-table'>
          <thead><tr><th style={{width:50}}>No.</th><th>Title</th><th>Body (excerpt)</th><th>Order</th><th>Actions</th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5}><div className='adm-empty'><div className='adm-empty-icon'>★</div><p>No advantage cards.</p></div></td></tr>}
            {items.map((a, idx) => (
              <tr key={a.id}>
                <td><span className='adm-badge adm-badge-blue'>{a.num}</span></td>
                <td style={{ fontWeight: 600 }}>{a.title}</td>
                <td style={{ color: '#555', fontSize: '.83rem', maxWidth: 300 }}>{a.body.length > 100 ? a.body.slice(0, 100) + '…' : a.body}</td>
                <td>
                  <div className='adm-order-col'>
                    <button className='adm-order-btn' onClick={() => move(idx, -1)} disabled={idx === 0}>▲</button>
                    <button className='adm-order-btn' onClick={() => move(idx, 1)}  disabled={idx === items.length - 1}>▼</button>
                  </div>
                </td>
                <td>
                  <div className='adm-actions'>
                    <button className='adm-btn adm-btn-outline adm-btn-sm' onClick={() => openEdit(a)}>Edit</button>
                    <button className='adm-btn adm-btn-danger  adm-btn-sm' onClick={() => del(a.id)}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {mode && (
        <div className='adm-modal-overlay' onClick={e => e.target === e.currentTarget && close()}>
          <div className='adm-modal adm-modal-lg'>
            <div className='adm-modal-header'>
              <h2 className='adm-modal-title'>{mode === 'add' ? 'Add Advantage Card' : 'Edit Advantage Card'}</h2>
              <button className='adm-close-btn' onClick={close}>✕</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className='adm-modal-body'>
                <div className='adm-form'>
                  <div className='adm-form-row'>
                    <div className='adm-form-group'>
                      <label className='adm-label'>Card Number (display)</label>
                      <input className='adm-input' value={form.num} onChange={field('num')} placeholder='01' />
                    </div>
                    <div className='adm-form-group'>
                      <label className='adm-label adm-label-req'>Title</label>
                      <input className='adm-input' value={form.title} onChange={field('title')} placeholder='Guaranteed 96% Zinc…' required />
                    </div>
                  </div>
                  <div className='adm-form-group'>
                    <label className='adm-label'>Body Text</label>
                    <textarea className='adm-input adm-textarea' style={{ minHeight: 120 }} value={form.body} onChange={field('body')} placeholder='Full description of this advantage…' />
                  </div>
                </div>
              </div>
              <div className='adm-modal-footer'>
                <button type='button' className='adm-btn adm-btn-ghost' onClick={close}>Cancel</button>
                <button type='submit' className='adm-btn adm-btn-primary'>{mode === 'add' ? 'Add Card' : 'Save'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvantagesAdmin;
